<template>
  <div class="finalScreen" v-if="me.game.active === true">
    <div class="finalScreen__center">
      <div class="finalScreen__center__header">Final overview</div>
      <TeamRankingTable TableWidth="full" />
      <div class="finalScreen__center__space"></div>
      <FinalDetailInfo TableWidth="full" />
      <div class="finalScreen__center__button">
        <div class="finalScreen__center__button__leave" @click="leaveGame">
          Leave game
        </div>
      </div>
      <div class="finalScreen__konfety"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TeamRankingTable from "@/components/game/table/tables/FinalTeamRanking.vue";
import FinalDetailInfo from "@/components/game/table/tables/FinalDetailInfo.vue";

export default {
  name: "FinalScreen",
  components: {
    TeamRankingTable,
    FinalDetailInfo,
  },
  methods: {
    async leaveGame() {
      this.$store.clearGameState();
      if (this.amIOwner == true || this.amIAdmin == true) {
        await this.$store.dispatch("fetchOwnActiveGames");
        await this.$store.dispatch("fetchOwnGames");
        await this.$store.dispatch("fetchOwnArchivedGames");
      }
      this.$router.push({
        name: this.imIOwner ? "GameManager.allGames" : "Join",
      });
    },
  },
  computed: {
    ...mapGetters(["amIOwner", "amIAdmin", "me"]),
  },
  async created() {
    await this.$store.dispatch("fetchProducts");
    await this.$store.dispatch("fetchArchivedProducts");
    await this.$store.dispatch("fetchProductsSales");
    await this.$store.dispatch("fetchCampaigns");
    await this.$store.dispatch("fetchTeam");
    await this.$store.dispatch("fetchTeamRanking");
    await this.$store.dispatch("fetchPurchasedData");
    await this.$store.dispatch("fetchMyTeamFinance");
  },
};
</script>
